define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/when",
	"csi/action/Controller",
	"csi/constants",
], function(declare, lang, when, Controller, constants) {

	return declare(Controller, {
		process: function() {
			// summary: respond to click on header
			const view = this.widget;
			const sd = view.scrollData;
			const th = view.getCell(this.targetElement, true);

			// if select multiple, do nothing
			if (!th) {
				this.postProcess();
				return;
			}

			const n = view.memoryTable.getCellIndex(th);

			// do nothing if this is selection column
			if (!n && view.allowsSelections()) {
				// delaying postProcess is a hack needed so that the postProcess runs after Select All checkbox on the popup table has finished making selections
				// this is needed to disable/enable Next and Finish buttons on the Wizard depending on whether selections were made
				setTimeout(() => this.postProcess(), 100);
				return;
			}

			if (this._ctrlKey && this._shiftKey) {
				// nothing to do
				this.postProcess();
			} else if (!this._ctrlKey && !this._shiftKey) {
				// only sort if ctrl and shift key are not pressed
				this.setProgress();
				when(view.sortByHeader(th), lang.hitch(this, this.postProcess, true, false));
			} else if (this._shiftKey) {
				// scroll column to left border - only makes sense if table is already frozen
				if (sd && sd.isFrozen()) {
					// scroll clicked column all the way to left - do nothing for frozen columns
					sd.setLeftBorder(n);

					// call postProcess without true so view not resized after scrolling horizontally
					this.postProcess();
				} else {
					this.displayErrorDialog({suffix: "_ErrorScroll"});
				}
			} else {
				// must be ctrl key - freeze clicked column if index within range;
				// frozen column should not include selection column in count
				const freezeIndex = view.getHeaderElementMaxIndex(th) - (view.allowsSelections() ? 1 : 0);

				if (freezeIndex >= constants.TABLE_MAX_FREEZE_COLUMNS) {
					this.displayErrorDialog({suffix: "_ErrorColumn"});
				} else {
					// call postProcess without true so view not resized after freezing
					view.freezeTable(freezeIndex);
					this.postProcess();
				}
			}
		}
	});
});